import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg518"
    width="290.309"
    height="77.23mm"
    version="1.1"
    viewBox="0 0 76.811 77.23"
  >
    <defs id="defs430">
      <clipPath id="clipPath23-4-7-7-7-2">
        <ellipse
          id="ellipse385"
          cx="-728.32"
          cy="87.544"
          fill="#f9b900"
          rx="109"
          ry="89.009"
          transform="rotate(-90)"
        ></ellipse>
      </clipPath>
      <clipPath id="clipPath21-3-8-7-7-1">
        <ellipse
          id="ellipse388"
          cx="-728.32"
          cy="89.546"
          fill="#f9b900"
          rx="109"
          ry="83.862"
          transform="rotate(-90)"
        ></ellipse>
      </clipPath>
      <clipPath id="clipPath25-3-0-6-6-7">
        <ellipse
          id="ellipse391"
          cx="-728.32"
          cy="89.003"
          fill="#f9b900"
          rx="109"
          ry="80.546"
          transform="rotate(-90)"
        ></ellipse>
      </clipPath>
      <clipPath id="clipPath20-54-4-4-2-9">
        <ellipse
          id="ellipse394"
          cx="-409.73"
          cy="113.17"
          fill="#f9b900"
          rx="109"
          ry="57.681"
          transform="rotate(-90)"
        ></ellipse>
      </clipPath>
      <clipPath id="clipPath1-9-3-3-7-6">
        <path
          id="rect397"
          strokeWidth="0.241"
          d="M-873.53-238.54h109v218h-109z"
        ></path>
      </clipPath>
      <clipPath id="clipPath16-5-9-2-3-6">
        <circle
          id="circle400"
          cx="-873.53"
          cy="-129.54"
          r="109"
          fill="#0081bf"
          clipPath="url(#clipPath1-9-3-3-7-6)"
          transform="matrix(0 -.8578 1 0 223.71 -28.03)"
        ></circle>
      </clipPath>
      <clipPath id="clipPath18-7-4-6-2-6">
        <circle
          id="circle403"
          cx="-873.53"
          cy="-129.54"
          r="109"
          fill="#0081bf"
          clipPath="url(#clipPath1-9-3-3-7-6)"
          transform="matrix(-1 0 0 -.67757 -151.25 -162.62)"
        ></circle>
      </clipPath>
      <clipPath id="clipPath418-1-8-1-0-7-7-9">
        <circle
          id="circle427"
          cx="-1229"
          cy="95.486"
          r="109"
          fill="none"
          stroke="#000"
          strokeWidth="3.923"
        ></circle>
      </clipPath>
    </defs>
    <g id="g516" transform="translate(-60.122 -70.314)">
      <g id="g436" transform="rotate(-76.206 89.145 131.2)">
        <g id="g434" transform="rotate(75.913 92.618 134.8)">
          <path
            id="path432"
            strokeWidth="0.265"
            d="M81.221 124.33q-.228.712-.694 1.126-.473.412-1.105.513-.64.099-1.359-.132-.719-.23-1.181-.682t-.608-1.062.083-1.322q.27-.847.866-1.248.591-.411 1.394-.302l-.304.947q-.41-.035-.719.185-.312.211-.462.681-.21.652.116 1.164.325.511 1.097.759.773.248 1.335.02.555-.23.764-.881.15-.47.04-.817-.116-.356-.45-.56l.303-.947q.682.367.918 1.043.237.669-.034 1.515m.74-2.482-3.621-3.813.451-.91 5.227.576-.426.86-1.2-.154-.856 1.725.846.869zm-.947-2.25.637-1.283-2.16-.268zm4.387-3.773q-.305.45-.69.69-.392.238-.813.243-.427 0-.845-.275l.535-.789q.294.183.623.125.327-.068.56-.412.203-.298.182-.568-.027-.275-.267-.437-.25-.17-.498-.108-.243.057-.505.254l-.56.423q-.484.362-.91.438-.424.071-.85-.218-.366-.24-.504-.59-.14-.358-.07-.763.064-.408.337-.811.277-.409.633-.62.36-.216.742-.213.385-.003.755.232l-.543.8q-.22-.141-.494-.089-.276.043-.47.33-.173.24-.159.497.012.247.251.409.204.139.414.093.204-.049.436-.215.233-.167.52-.39.311-.232.622-.388.31-.156.647-.149.33.003.692.248.322.218.485.568t.115.786q-.054.432-.371.899m2.12-2.918-3.165-2.779-.95 1.082-.546-.479 2.499-2.848.546.48-.954 1.087 3.166 2.778zm2.04-2.23-3.285-3.69 2.408-2.143.484.542-1.734 1.544.901 1.012 1.575-1.403.47.527-1.576 1.403.948 1.064 1.734-1.544.483.543zm3.088-2.667-2.824-4.052.74-.516 2.422 3.473 1.794-1.251.404.579zm3.223-2.178-2.337-4.351.796-.428 2.003 3.73 1.927-1.035.333.622zm3.45-1.795-1.804-4.598 3.002-1.178.265.677-2.16.848.495 1.261 1.963-.77.258.656-1.964.77.521 1.327 2.16-.848.266.677zm3.818-1.444-1.21-4.788 1.758-.444q.574-.146.994-.04.424.096.694.384.268.282.37.685.11.438-.03.86-.135.42-.579.706l1.499 1.754-1.006.254-1.366-1.663-.725.183.477 1.888zm.236-2.752.828-.21q.437-.11.589-.374t.063-.613q-.086-.342-.343-.495-.25-.155-.702-.04l-.82.207zm5.729 1.624q-.54.064-.975-.068-.436-.14-.715-.455-.28-.322-.347-.818l.946-.113q.055.341.315.552.265.202.679.153.357-.043.547-.236.19-.2.155-.488-.036-.301-.246-.447-.202-.146-.523-.214l-.685-.145q-.591-.128-.93-.4-.33-.274-.392-.785-.059-.434.115-.767.179-.341.53-.554.35-.22.834-.277.49-.06.882.072.4.13.648.42.255.289.32.721l-.96.115q-.037-.258-.257-.43-.213-.181-.557-.14-.295.028-.48.207-.178.17-.143.457.029.246.2.374.172.122.45.188t.634.137q.38.083.701.215t.537.39q.215.252.267.686.046.385-.11.738-.157.353-.518.602-.362.242-.922.31m4.189-.376.338-4.927 1.682.115q.866.06 1.4.407.543.342.772.916.237.568.186 1.314t-.364 1.284q-.305.53-.89.801-.576.265-1.442.206zm.954-.712.74.05q.619.043.991-.13.373-.18.553-.542.181-.37.218-.904.036-.528-.093-.919-.128-.39-.473-.62-.345-.228-.965-.27l-.739-.051zm4.545-2.633.156-1.47.78.13-.33 1.44zm.813 4.021 1.193-4.793 3.129.779-.176.705-2.252-.56-.327 1.314 2.047.51-.17.684-2.048-.51-.344 1.384 2.253.56-.176.706zm5.49 1.724q-.508-.195-.83-.516-.32-.327-.42-.735-.098-.416.075-.886l.889.342q-.111.327.02.635.141.303.53.452.336.13.594.047.26-.089.364-.359.11-.283-.008-.51-.11-.223-.362-.433l-.538-.449q-.463-.39-.635-.788-.165-.396.02-.877.15-.41.458-.624.318-.218.728-.243.412-.03.867.144.46.177.747.476.292.301.376.673.09.375-.053.789l-.903-.347q.087-.246-.026-.501-.105-.26-.428-.383-.274-.113-.52-.042-.238.068-.342.338-.088.23.003.424.095.188.31.376t.497.418q.297.25.52.517.222.266.292.596.073.322-.084.73-.14.363-.442.602-.304.239-.74.29-.432.046-.96-.156zm3.323 1.402 1.975-3.721-1.271-.675.34-.642 3.347 1.777-.34.641-1.278-.678-1.975 3.721zm4.331 2.78q-.598-.437-.857-1.028-.253-.586-.172-1.235.09-.65.536-1.26.445-.61 1.033-.888.597-.28 1.233-.218.642.067 1.24.504.592.433.851 1.023t.168 1.242q-.086.644-.531 1.254t-1.037.894q-.588.278-1.23.212-.641-.067-1.234-.5m.479-.655q.57.416 1.18.285.617-.126 1.095-.781t.412-1.281q-.062-.622-.632-1.038t-1.186-.29-1.095.782-.411 1.281.637 1.042m3.67 4.242q-.526-.533-.677-1.137-.146-.61.057-1.217.209-.613.746-1.143t1.152-.731 1.222-.048q.608.154 1.134.686.624.632.705 1.346.09.714-.378 1.375l-.699-.708q.222-.348.17-.722-.043-.375-.39-.726-.481-.487-1.086-.436-.604.051-1.18.621-.578.57-.637 1.174-.053.598.428 1.085.347.352.706.414.369.062.704-.14l.7.707q-.642.435-1.35.331-.703-.099-1.327-.731m3.376 4.031q-.43-.603-.489-1.245-.054-.637.227-1.227.291-.588.907-1.026.615-.438 1.26-.516.656-.077 1.24.183.587.266 1.016.87.426.597.485 1.24.058.642-.233 1.23-.286.585-.9 1.022-.616.438-1.267.52-.646.08-1.233-.187-.588-.266-1.013-.864m.66-.47q.41.575 1.03.644.625.075 1.286-.396.661-.47.795-1.085.138-.61-.27-1.184-.41-.575-1.035-.65t-1.286.396q-.66.47-.795 1.085-.133.615.276 1.19m1.198 3.156 4.387-2.269.415.802-3.76 1.945 1.004 1.943-.626.324zm1.804 3.456 4.678-1.584.344 1.016-2.462 2.495 3.465.465.344 1.016-4.679 1.584-.29-.856 3.229-1.092-3.001-.437-.229-.675 2.119-2.17-3.228 1.093z"
            ariaLabel="CASTELLERS D'ESTOCOLM"
            transform="translate(-15.112 -19.703)"
          ></path>
        </g>
      </g>
      <g id="g514" transform="translate(-14.445 -25.504)">
        <g id="g460" transform="matrix(1.1 0 0 1.1 45.37 -120.6)">
          <circle
            id="circle440"
            cx="61.504"
            cy="232.07"
            r="27.71"
            fill="#f9b900"
          ></circle>
          <g
            id="g450"
            fill="#840301"
            transform="translate(245.32 209.04)scale(.25422)"
          >
            <path
              id="rect442"
              d="M-10.355 741.55h215.91v13.223h-215.91z"
              clipPath="url(#clipPath23-4-7-7-7-2)"
              transform="matrix(0 1.2246 -1 0 5.256 -16.584)"
            ></path>
            <path
              id="rect444"
              d="M-10.355 764.66h204.28v13.223h-204.28z"
              clipPath="url(#clipPath21-3-8-7-7-1)"
              transform="matrix(0 1.2998 -1 0 5.256 -25.766)"
            ></path>
            <path
              id="rect446"
              d="M-10.355 787.77h186.39v13.223h-186.39z"
              clipPath="url(#clipPath25-3-0-6-6-7)"
              transform="matrix(0 1.3533 -1 0 5.256 -29.822)"
            ></path>
            <path
              id="rect448"
              d="M1.103 492.28h197.61v13.223H1.103z"
              clipPath="url(#clipPath20-54-4-4-2-9)"
              transform="matrix(0 1.8897 -1 0 -313.34 -123.24)"
            ></path>
          </g>
          <circle
            id="circle452"
            cx="-873.53"
            cy="-129.54"
            r="109"
            fill="#0081bf"
            clipPath="url(#clipPath1-9-3-3-7-6)"
            transform="translate(283.57 265)scale(.25422)"
          ></circle>
          <g
            id="g458"
            fill="#f9b900"
            transform="translate(245.32 209.04)scale(.25422)"
          >
            <path
              id="rect454"
              d="M54.35 614.28h22.781v107.01H54.35z"
              clipPath="url(#clipPath16-5-9-2-3-6)"
              transform="matrix(0 1 -1.1658 0 117.79 -3.553)"
            ></path>
            <path
              id="rect456"
              d="M656.39-195.43h22.781V10.1H656.39z"
              clipPath="url(#clipPath18-7-4-6-2-6)"
              transform="matrix(-1 0 0 -1.4759 -.788 -19.846)"
            ></path>
          </g>
        </g>
        <g id="g498" transform="matrix(1.1 0 0 1.1 45.37 -120.6)">
          <path
            id="path462"
            d="M233.82 832.11c-4.572 0-9.803.661-15.188 2.13l.814 2.358 3.616.834v17.87l-4.239 1.982-.408 2.3 1.397.918-.955 3.483-10.838 3.984 2.177.49v64.812l-47.559 5.883-7.37 8.592a104.73 104.73 0 0 0 77.188 34.11 104.73 104.73 0 0 0 78.422-35.46l.156-1.564 2.297-2.498-5.35-11.043-51.454-1.684-.543-64.119-27.67-1.709 27.67 1.707 2.37-.777-15.27-2.348.213-2.695.304.062 1.319-2.978-4.611-2.094v-17.14l4.148-2.286-1.4-1.986c-2.522-.734-5.68-1.135-9.237-1.135zm-.512 11.211.084 8.113-3.26-.2-.189-7.145zm6.422 28.215c.225-.034.414.657.895 1.639v5.853l-1.66-.03.019-5.858c.374-1.111.571-1.577.746-1.604m5.68 0c.225-.034.411.657.892 1.639v5.853l-1.66-.03.02-5.858c.374-1.111.573-1.577.748-1.604"
            transform="scale(.26458)"
          ></path>
          <path
            id="path488"
            stroke="#000"
            strokeWidth="0.178"
            d="M61.485 214.6v-.928m-.024.955-3.823-2.221m3.873 2.221 3.823-2.221"
          ></path>
          <path
            id="path492"
            d="m-1226.9 26.307-1.24.035-.176 5.751-.553.696.79 1.237-.066 1.805-.515 7.957c.78 3.967-3.444 3.797-5.029 5.186l-2.632-3.042-1.76 4.292 19.394-.976c-.297-.152.323-1.062-1.157-4.098-.338-.695-1.68 3.01-2.732 2.804-1.425-.28-3.696-2.995-3.985-4.313l-.225-7.695z"
            clipPath="url(#clipPath418-1-8-1-0-7-7-9)"
            transform="translate(373.54 207.8)scale(.25422)"
          ></path>
          <ellipse
            id="ellipse494"
            cx="61.484"
            cy="216.09"
            rx="0.512"
            ry="0.487"
          ></ellipse>
          <path
            id="path496"
            d="m-1235.1 41.088-8.871.96-5.267-7.203 3.604-8.162 8.872-.96 5.266 7.202z"
            transform="matrix(.11982 .01404 -.01167 .1441 210.51 230.53)"
          ></path>
          <path
            id="path472-3"
            fill="#000"
            fillOpacity="1"
            strokeWidth="0.254"
            d="m61.5 211.88-.549.932-.055.094-.765-.33.197 1.2h2.299l.197-1.2-.747.322-.043-.076z"
          ></path>
          <path
            id="path472-6"
            fill="#000"
            fillOpacity="1"
            strokeWidth="0.254"
            d="m65.227 210.649-.549.933-.055.094-.765-.33.197 1.199h2.299l.197-1.199-.747.322-.043-.077z"
          ></path>
          <path
            id="path472-3-5"
            fill="#000"
            fillOpacity="1"
            strokeWidth="0.254"
            d="m57.77 210.649-.548.933-.056.094-.764-.33.197 1.199h2.298l.197-1.198-.746.32-.044-.076z"
          ></path>
        </g>
        <path
          id="path500"
          fill="#f9b900"
          d="M108.34 138.61c-.16.022-.39.181-.49.878 0 0-.25 1.032-.377 2.005 0 0-.314 2.738-.06 4.582 0 0 .062.504.306.82 0 0 1.21 1.363 1.473 1.568 0 0 .174.122-.012.457 0 0-.258.257-.014 1.036 0 0 .11.385.348.707 0 0 .141.212.373.212 0 0 .244 1.614.366 3.267 0 0 .033.373.013.695 0 0-.038.72.07 1.138 0 0 .072.444.014.605s-.238.714-.27.79a7 7 0 0 0-.226.785c-.038.219.027.605-.199.952-.128.218-.174.354-.174.354s-.007.09-.186.115c-.18.026-.418.007-.52.097-.104.09-.4.045-.592-.058-.193-.103-1.32-.36-1.814-.334-.553.013-1.335-.032-1.961.547 0 0-.692.583-.764 1.983-.046.496-.049 1.166-.04 1.832a30.5 30.5 0 0 0 9.416 1.511 30.5 30.5 0 0 0 9.036-1.404c-.254-.632-.728-1.764-1.031-2.184-.428-.591-.692-.955-1.483-1.292s-1.155-.382-1.473-.618c-.319-.237.114-.514.214-.617s.3-.257.302-.44c0 0 .794-.47.781-1.113-.012-.643.04-1.736-.745-2.637 0 0 .2-.096.47-.623.27-.528.308-1.183.275-1.505s-.199-1.267-.379-1.679a2.84 2.84 0 0 0-.83-1.042c-.321-.25-.662-.36-.778-.803-.01-.027-.042-.141-.051-.264s-.128-.41-.405-.423c-.278-.014-.535.013-.605-.041-.041-.034-.055-.096-.027-.196 0 0 .175-.176.207-.305 0 0 .052-.077.097-.096 0 0 .07-.032.09-.212s.007-.296.058-.341.444-.365.52-1.031c.013-.058 0-.487-.244-.835 0 0-.046-1.463-.31-1.94 0 0-.345-.724-1.082-.86 0 0-.11-.01-.21-.046 0 0-.39-.182-.613-.2-.068-.004-.52-.025-.728.014 0 0-.433.103-.594.197 0 0-.375.19-.579.475-.046.065-.083.168-.27.225 0 0-.385.161-.45.22 0 0-.096.09-.077.147 0 0 .045.113-.013.167 0 0-.148.155-.084.193 0 0 .129.058.142.141 0 0 .022.12-.039.232 0 0-.07.116.02.2 0 0 .07.09.064.218 0 0-.026.527.007.701 0 0 .015.085.034.126 0 0 .047.151.072.257 0 0 .02.063.055.106 0 0 .054.074-.033.135 0 0-.392.424.093 1.006 0 0 .161.245.553.223 0 0 .068-.03.1.189 0 0 .061.52.058.62 0 0-.054.085-.283.043 0 0-.566-.216-.74-.344 0 0-.411-.232-.771-.232 0 0-.187-.495-.502-.482 0 0-.16.019-.199.032 0 0-.93-.711-1.148-1.039 0 0-.4-1.564-.527-1.91 0 0-.419-1.646-.364-2.374 0 0 .018-.49 1.182-.527 0 0 .747-.01.747-.562 0 0 .708-.206.727-.688 0 0 .135-.07.09-.212 0 0-.051-.158-.26-.08 0 0-.476.189-.685.199 0 0-.174-.03-.058-.129 0 0 .54-.35.61-.505 0 0 .112-.156-.002-.283 0 0-.141-.178-.441.077 0 0-.646.46-1.328.56-.018.008-.41.045-.51-.06-.059-.095-.081-.14-.013-.364 0 0 .191-.536-.155-.686 0 0-.069-.036-.165-.023z"
        ></path>
        <circle
          id="circle502"
          cx="113.02"
          cy="134.68"
          r="30.481"
          fill="none"
          stroke="#000"
          strokeWidth="1.097"
        ></circle>
        <circle
          id="circle504"
          cx="134.68"
          cy="-113.02"
          r="33.529"
          fill="none"
          transform="rotate(90)"
        ></circle>
        <g id="g512" transform="rotate(12.95 113.02 134.68)">
          <g id="g510" transform="rotate(-90 112.96 134.68)">
            <path
              id="path506"
              strokeWidth="0.265"
              d="m75.427 126.69.41.07q.305.56.627 1.066.327.515.658.922.33.414.673.673.34.266.688.326.258.044.496-.008.236-.046.402-.218.172-.17.23-.505.054-.32-.055-.56-.102-.24-.32-.391-.218-.145-.49-.191l.097-.564q.48.082.786.342.313.261.434.64.122.379.047.817-.11.647-.55.994-.432.355-1.156.232-.43-.074-.818-.362-.38-.287-.72-.689-.332-.4-.608-.84-.276-.435-.492-.808l-.402 2.35-.486-.082zm-.837 5.913q.036-.656.38-1.117.35-.454.934-.677.591-.221 1.352-.18t1.318.327q.563.286.855.775.297.497.261 1.152-.036.656-.386 1.11-.343.454-.935.676-.584.222-1.345.18-.76-.041-1.325-.327-.556-.285-.854-.775-.291-.49-.255-1.144m.521.028q-.024.43.197.781.228.36.668.574.447.223 1.081.258.634.034 1.096-.138.461-.165.72-.497.265-.325.289-.755.024-.436-.204-.788-.221-.352-.661-.574t-1.074-.257-1.103.138q-.462.172-.727.497-.258.325-.282.761m-.515 2.792.415-.024q.424.477.852.897.435.426.85.748.414.33.806.504.393.182.745.161.26-.015.48-.12.221-.098.343-.303.13-.205.11-.543-.02-.324-.18-.534-.154-.21-.4-.308-.246-.092-.52-.076l-.034-.57q.486-.029.843.155.364.184.568.525t.23.785q.039.655-.31 1.093-.342.444-1.074.487-.437.026-.88-.168-.435-.193-.856-.507-.414-.315-.782-.682-.368-.36-.662-.675l.14 2.38-.493.03zm.648 6.192 1.044-.174-.412-2.471.453-.075 3.77 1.803.113.682-3.312.552.12.724-.515.086-.12-.724-1.044.174zm1.255-2.084.309 1.852 2.665-.445z"
              ariaLabel="2024"
              transform="rotate(-12.965 112.96 134.75)"
            ></path>
            <circle
              id="ellipse508"
              cx="113.02"
              cy="-134.68"
              r="38.406"
              fill="none"
              transform="scale(1 -1)"
            ></circle>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgIcon;
